import LeftArrow from 'assets/icons/arrow-left-dark.svg'
import styles from './BackLink.module.css'

interface Props {
  url: string
  title: string
  dataTestId?: string
}

const BackLink = ({ url, title, dataTestId }: Props) => {
  return (
    <a
      href={url}
      className={styles.link}
      data-trk-general="backlink"
      data-testid={dataTestId}
    >
      <LeftArrow className={styles.icon} />
      {title}
    </a>
  )
}

export default BackLink
